import Joi from 'joi'
import {inputPhoneValidation, inputStringValidation} from 'validation'

export const createCompanySchema = Joi.object({
  name: inputStringValidation.required().messages({
    'string.empty': `name cannot be an empty field`,
    'any.required': `name is a required field`,
    'string.min': `name should have a minimum length of 2 characters`,
    'string.max': `name should have a maximum length of 20 chatacters or less`,
  }),
  url: inputStringValidation.allow(''),
  bindWithDomain: Joi.boolean(),
  description: inputStringValidation.allow(''),
  domain: Joi.string().domain().allow(null, ''),
  address: {
    country: inputStringValidation.allow(''),
  },
  tags: Joi.array(),
  notes: Joi.array(),
})

export const companytDetailLeftSchema = Joi.object({
  name: Joi.string().trim().min(2).max(50).required(),
  domain: Joi.string().domain().allow(null, ''),
  description: Joi.string().trim().min(3).max(150).allow(''),
  fields: Joi.object(),
  address: Joi.object({
    country: inputStringValidation.allow('').optional().label('country'),
    locality: inputStringValidation.allow('').optional().label('locality'),
    streetAddress: inputStringValidation.allow('').optional().label('street address'),
    postalCode: Joi.string().alphanum().allow(null, '').optional().label('postal code'),
  }).optional(),
})

export const companyDetailsRightSchema = Joi.object({
  phone: inputPhoneValidation.allow('', null),
  url: inputStringValidation.allow('').optional(),
})

export const companySegmentStep1Schema = Joi.object({
  name: Joi.string().trim().required().messages({
    'string.empty': `Name is not allowed to be empty`,
  }),
  isStatic: Joi.boolean(),
})
export const companySegmentStep2Schema = Joi.object({
  ids: Joi.array().items(Joi.number().integer()),
  conditions: Joi.object({
    tag: Joi.number().allow('', null).label('Tags'),
    company: Joi.number().allow('', null),
    country: Joi.string().allow('', null),
    isFavourite: Joi.string().allow('', null),
  }),
})
